"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = (0, _makeStyles["default"])(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    wrapper: {
      position: 'relative',
      '&:hover, &:focus-within': {
        '& $nested': {
          visibility: 'visible',
          opacity: 1,
          transform: 'none'
        }
      }
    },
    link: function link(_ref2) {
      var isMultiColumns = _ref2.isMultiColumns,
          columns = _ref2.columns;
      return {
        textDecoration: 'none',
        '&:focus': {
          '& + $nested': {
            visibility: 'visible',
            opacity: 1,
            transform: 'none'
          }
        },
        '& span': {
          justifyContent: isMultiColumns && columns > 1 ? 'flex-start' : 'center'
        }
      };
    },
    nested: function nested(_ref3) {
      var isMultiColumns = _ref3.isMultiColumns,
          rows = _ref3.rows,
          columns = _ref3.columns;
      return {
        display: isMultiColumns ? 'grid' : 'block',
        gridAutoFlow: 'column',
        gridTemplateColumns: "repeat(".concat(columns, ", max-content)"),
        gridTemplateRows: "repeat(".concat(rows, ", 1fr)"),
        gap: '5px 5px',
        position: 'absolute',
        top: '96%',
        left: 0,
        minWidth: 175,
        visibility: 'hidden',
        opacity: 0,
        width: 'auto',
        padding: spacing(1),
        backgroundColor: palette.background.paper,
        transform: 'translateY(15px)',
        transitionProperty: 'opacity,transform',
        transitionDuration: 250,
        transitionDelay: 75,
        zIndex: 1000,
        '&::before': {
          width: 0,
          height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderBottom: "7px solid ".concat(palette.background.paper),
          position: 'absolute',
          bottom: '100%',
          left: '1.5rem',
          content: '""'
        }
      };
    },
    root: {
      display: 'flex'
    }
  };
});

exports["default"] = _default;